exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dataInfo {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    background: #000;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    z-index: 999999;\n}\r\n", ""]);

// exports
